<template>
  <!-- :class="[isiOS && 'iosPadding']" -->
  <div class="home-layout">
    <div class="router-view-box">
      <slot name="routerView"></slot>
    </div>

    <van-tabbar
      v-show="!userStore.isDisabled"
      v-model="active"
      route
      fixed
      placeholder
      :border="false"
      :style="getStyle"
      class="custom-tabbar"
    >
      <div class="back-top" v-if="showTopIcon">
        <img src="@/assets/images/home/top_back.png" @click="backTop" />
        <p>回到顶部</p>
      </div>
      <van-tabbar-item replace to="/home" v-else>
        <span>首页</span>
        <template #icon="props">
          <img
            :src="props.active ? icon[0].active : icon[0].inactive"
            class="tabBar-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/applyList">
        <span>用印</span>
        <template #icon="props">
          <img
            :src="props.active ? icon[1].active : icon[1].inactive"
            class="tabBar-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace @click="showSheet">
        <template #icon="props">
          <img
            src="@/assets/images/tabBar/application-seal.png"
            class="tabBar-center"
          />
        </template>
        <span style="color: rgba(19, 19, 20, 1);">发起用印</span>
      </van-tabbar-item>
      <van-tabbar-item replace to="/deviceManage" >
        <span>设备</span>
        <template #icon="props">
          <img
            :src="props.active ? icon[2].active : icon[2].inactive"
            class="tabBar-icon"
          />
        </template>
      </van-tabbar-item>
      <van-tabbar-item replace to="/me">
        <span>我的</span>
        <template #icon="props">
          <img
            :src="props.active ? icon[3].active : icon[3].inactive"
            class="tabBar-icon"
          />
        </template>
      </van-tabbar-item>
      <div class="tab-bg"></div>
    </van-tabbar>

    <ProcessModal
      :processShow="popupShow"
      :deptList="beforeApplyState.deptList"
      @changeShow="changeShow"
      @closePop="closePop"
      @toApply="toApply"
    ></ProcessModal>

    <ocrPopup
      :show="beforeApplyState.ocrPopupShow"
      :clearShow="true"
      @submit="ocrSubmit"
    />
  </div>
</template>
<script>
import {useUserStore, useDeviceStore} from '@/store/home'

import { RouterView, useRouter, useRoute } from 'vue-router'
import { ref, onUnmounted, computed, onMounted, reactive, toRefs } from 'vue'
import homeSelected from '@/assets/images/tabBar/home-selected.png'
import homeUnselected from '@/assets/images/tabBar/home-unselected.png'
import approveSelected from '@/assets/images/tabBar/approval-selected.png'
import approveUnselected from '@/assets/images/tabBar/approval-unselected.png'
import sealSelected from '@/assets/images/tabBar/seal-selected.png'
import sealUnselected from '@/assets/images/tabBar/seal-unselected.png'
import deviceSelected from '@/assets/images/tabBar/device-selected.png'
import deviceUnselected from '@/assets/images/tabBar/device-unselected.png'
import meSelected from '@/assets/images/tabBar/me-selected.png'
import meUnselected from '@/assets/images/tabBar/me-unselected.png'
import applicationSeals from '@/assets/images/home/6.png'
import electronics from '@/assets/images/apply/electronics.png'
import entity from '@/assets/images/apply/entity.png'
import check from '@/assets/images/device/check.png'
import nocheck from '@/assets/images/device/nocheck.png'
import { useDealFormItems } from '@/hooks/useDealFormItems'
import { Dialog, Toast } from 'vant'
import searchIcon from '@/assets/images/selectSeal/search.png'

import 'vant/es/dialog/style'

// ocr到期弹窗
import ocrPopup from '@/components/ocrWarnPopup/index.vue'
import ProcessModal from '@/components/ProcessModal/index.vue'

//引入pinia仓库
import { useHomeStore } from '@/store/home'
import { useToggle } from '@vant/use'
import throttle from 'lodash/throttle'
import { useBeforeApply } from '@/hooks/useBeforeApply'

export default {
  components: {
    ocrPopup,
    ProcessModal
  },
  setup() {
    const businessList = ref([])
    const standbyBusinessList = ref([])
    const router = useRouter()
    const route = useRoute()
    const { popupShow, beforeApplyState, changeShow, closePop, toApply, showSheet, ocrSubmit } = useBeforeApply()

    const state = reactive({
      ocrPopupShow: false, // ocr预警弹窗
      deptList: [], // 部门列表
      keyboardHeight: 0 // 键盘高度
    })
    // 初始窗口高度
    const winHeight = ref(0)

    const isiOS = computed(() => {
      const u = navigator.userAgent
      return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
    })
    // 获取底部导航颜色
    const getStyle = computed(() => {
      return route.path !== '/home'
        ? { background: 'transparent' }
        : { background: '#f5f6f7' }
    })

    const homeStore = useHomeStore()
    const userStore = useUserStore()
    const badge = computed(() => homeStore.badge || '')
    const active = ref(0)
    const icon = [
      {
        active: homeSelected,
        inactive: homeUnselected
      },
      {
        active: sealSelected,
        inactive: sealUnselected
      },
      {
        active: deviceSelected,
        inactive: deviceUnselected
      },
      {
        active: meSelected,
        inactive: meUnselected
      }
    ]
    const authStatus = ref()
    const { dealControlData } = useDealFormItems()
    const reloadList = ['/home', '/approveList', '/me']

    // 获取待审批角标
    homeStore.getBadge()

    // 监听滚动区域，显示置顶按钮
    const [showTopIcon, toggle] = useToggle()
    toggle(false)
    const handleScroll = throttle(() => {
      if (route.path !== '/home') {
        toggle(false)
        return
      }
      const height =
        document.documentElement.scrollTop || document.body.scrollTop
      if (showTopIcon.value && height < 310) {
        toggle(false)
      } else if (!showTopIcon.value && height > 310) {
        toggle(true)
      }
    }, 100)
    window.addEventListener('scroll', handleScroll)


    // 回到顶部
    function backTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
    onMounted(() => {
      // 记录初始窗口高度
      winHeight.value = window.innerHeight

      // 监听窗口大小变化（键盘弹出会触发）
      window.addEventListener('resize', handleResize)
      window.addEventListener(
        'popstate',
        () => {
          const pathName = window.location.pathname
          if (reloadList.includes(pathName)) {
            // window.location.reload()
          }
        },
        false
      )
    })

    // 处理窗口大小变化
    const handleResize = () => {
      const focusedElement = document.querySelector(':focus')
      console.log('当前聚焦元素', focusedElement)
      //是否有聚焦元素
      if (focusedElement) {
        const thisHeight = window.innerHeight
        state.keyboardHeight = thisHeight - winHeight.value
        // console.log('键盘高度', state.keyboardHeight)
        // console.log('初始窗口高度', winHeight.value)
        // console.log('窗口高度', thisHeight)
      } else {
        state.keyboardHeight = 0
      }
    }

    onUnmounted(() => {
      window.removeEventListener('scroll', handleScroll)
      window.removeEventListener('resize', handleResize)
    })

    return {
      searchIcon,
      popupShow,
      active,
      icon,
      showTopIcon,
      backTop,
      RouterView,
      applicationSeals,
      electronics,
      entity,
      homeStore,
      userStore,
      showSheet,
      toApply,
      authStatus,
      closePop,
      businessList,
      badge,
      isiOS,
      getStyle,
      ...toRefs(state),
      beforeApplyState,
      ocrSubmit,
      nocheck,
      check,
      changeShow
    }
  }
}
</script>

<style lang="less" scoped>
.custom-tabbar {
  position: fixed;
}
// 底部tab整体
:deep(.van-safe-area-bottom) {
  height: 103px;
  width: 100%;
  background-image: url('@/assets/images/tabBar/tab-bg.png');
  background-size: 100%;
  background-position: 0 0;
  background-repeat: no-repeat;
  box-sizing: border-box;
  background-color: transparent;
  position: fixed;
  bottom: v-bind('keyboardHeight + "px"');
  left: 0;
  // align-items: flex-end;
  .mixin-custom-style-safe-basic(@paddingBottom,22px,@safeAreaInsetBottom,16px);
  // .mixin-custom-style-safe(@paddingBottom, @dynamicPaddingBottom, 0rem);
  // box-sizing: content-box;

  // &::after {
  //   position: absolute;
  //   left: 0;
  //   bottom: 0;
  //   content: '';
  //   display: block;
  //   width: 100%;
  //   .mixin-custom-style-safe(@height, @dynamicPaddingBottom, 0rem);
  //   background-color: #fff;
  // }

  .van-tabbar-item {
    height: min-content;
    margin-top: 36px;
  }

  .application-seal {
    margin-top: 0;
  }
}

// 选中样式
:deep(.van-tabbar-item--active) {
  background-color: transparent;

  .van-tabbar-item__text {
    span {
      color: #f04136;
      font-weight: 800;
    }
  }
}

:deep(.van-tabbar-item__text) {
  span {
    color: #969799;
    font-size: 12px;
    font-weight: 400;
  }
}

.icon {
  width: 84px;
  height: 84px;
  position: fixed;
  bottom: 111px;
  right: 14px;
}

.tabBar-icon {
  width: 28px;
  height: 28px;
}

// 中间tab标
.tabBar-center {
  width: 28px;
  height: 28px;
  // background: linear-gradient(126deg, #e85751 0%, #e22227 100%);
  // box-shadow: 0px 2px 14px 0px rgba(249, 79, 72, 0.29);
  // margin-top: 18px;
  // margin-bottom: 3px;
}

.back-top {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  line-height: 12px;

  img {
    width: 28px;
    height: 28px;
    margin-bottom: 4px;
  }
  p {
    font-size: 12px;
    color: #f04136;
    font-weight: 500;
  }
}

.text-ellipsis {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.home-layout,
.router-view-box {
  height: 100%;
  box-sizing: border-box;
}
.router-view-box {
  overflow-y: scroll;
}
</style>
